module.exports = __webpack_public_path__ + "static/media/shopify7.51ef1894.png";